import * as posActions from "../../lib/posActions";
import * as routeHelpers from "../../lib/routeHelpers";
import Drawer from "../Drawer";
import ErrorModal from "../ErrorModal";
import OutlineButton from "../OutlineButton";
import React from "react";
import styles from "./ManagerRemoveTill.module.css";
import TextButton from "../TextButton/TextButton";
import tillIcon from "../../images/till.svg";
import {useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../lib/hooks";

const strings = {
    no: "No, Thanks",
    removeHeader: (tillNumber: number) => `Remove Assigned Till #${tillNumber}`,
    removeButtonPrompt: (tillNumber: number) => `Remove Till #${tillNumber}`,
    mainPrompt: "Are you sure you want to remove the currently assigned till?",
    subPrompt:
        "Doing so will require you to select a new till before accepting more orders",
};

export default function ManagerRemoveTill() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isTraining = useAppSelector((state) => state.pos.station.isTraining);

    const assignedTill = useAppSelector(
        (state) => state.pos.station.assignedTill,
    );
    const trainingModeAssignedTill = useAppSelector(
        (state) => state.pos.station.trainingModeAssignedTill,
    );
    const isAssigningTill = useAppSelector(
        (state) => state.pos.station.isAssigningTill,
    );
    const tillAssignmentErrorMessage = useAppSelector(
        (state) => state.pos.errors.tillAssignmentErrorMessage,
    );

    const currentStationMode = useAppSelector(
        (state) => state.pos.station.mode,
    );

    function navigateToDeviceSetup() {
        navigate(routeHelpers.deviceSetup(), {
            state: {
                skipCCRegistrationCheck:
                    currentStationMode === "drive_thru_order_taker" ||
                    currentStationMode === "line_buster",
            },
        });
        dispatch(posActions.setStationCashier({type: "user"}));
    }

    function onClose() {
        navigate(routeHelpers.managerMenu());
    }

    function onRemoveTill() {
        dispatch(posActions.assignTill(-1)).then(navigateToDeviceSetup);
    }

    function onCloseErrorModal() {
        dispatch(posActions.setTillAssignmentErrorMessage(undefined));
    }

    return (
        <Drawer onClose={onClose} size="small">
            <div className={styles.header}>
                {strings.removeHeader(
                    isTraining ? trainingModeAssignedTill : assignedTill,
                )}
            </div>
            <div className={styles.bodyContainer}>
                <img className={styles.image} src={tillIcon} alt="" />
                <div className={styles.mainPrompt}>{strings.mainPrompt}</div>
                <div className={styles.subPrompt}>{strings.subPrompt}</div>
                <OutlineButton
                    className={styles.removeButton}
                    label={strings.removeButtonPrompt(
                        isTraining ? trainingModeAssignedTill : assignedTill,
                    )}
                    labelClassName={styles.removeButtonLabel}
                    onClick={onRemoveTill}
                    disabled={isAssigningTill}
                    mode="blue"
                />
                <TextButton
                    className={styles.noButton}
                    label={strings.no}
                    onClick={onClose}
                    disabled={isAssigningTill}
                />
            </div>
            {tillAssignmentErrorMessage ? (
                <ErrorModal
                    errorMessage={tillAssignmentErrorMessage}
                    onClose={onCloseErrorModal}
                    showITInfo
                />
            ) : null}
        </Drawer>
    );
}
